var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AsyncStorage from "@react-native-async-storage/async-storage";
const PREFIX = "nha_";
const addPrefix = (key) => `${PREFIX}${key}`;
export const setStorageValue = (key, value) => __awaiter(void 0, void 0, void 0, function* () {
    if (value === null) {
        yield removeStorageValue(key);
    }
    else {
        yield AsyncStorage.setItem(addPrefix(key), JSON.stringify(value));
    }
});
export const getStorageValue = (key) => __awaiter(void 0, void 0, void 0, function* () {
    const jsonValue = yield AsyncStorage.getItem(addPrefix(key));
    return jsonValue != null ? JSON.parse(jsonValue) : null;
});
export const removeStorageValue = (key) => __awaiter(void 0, void 0, void 0, function* () {
    yield AsyncStorage.removeItem(addPrefix(key));
});
